import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import Article from "./Article";
import { useI18nField, useL } from "../locale/LocaleContext";
import { useSubdeptPageMeta } from "./hooks/useSubdeptMeta";

const SubdepartmentArticles = () => {
  const { deptId, subdeptId } = useParams();
  useSubdeptPageMeta(deptId, subdeptId);
  const [articles, setArticles] = useState([]);
  const [subdeptDoc, setSubdeptDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const f = useI18nField(); // Firestore fields (strings only)
  const t = useL();         // UI labels (strings or {en,fr})

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      try {
        // 1) Subdepartment doc for localized title
        const subRef = doc(db, "departments", deptId, "subdepartments", subdeptId);
        const subSnap = await getDoc(subRef);
        setSubdeptDoc(subSnap.exists() ? { id: subSnap.id, ...subSnap.data() } : null);

        // 2) Articles under this subdepartment
        const articleRef = collection(subRef, "articles");
        const snapshot = await getDocs(articleRef);
        const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setArticles(data);
      } catch (err) {
        console.error("Error fetching subdepartment/articles:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [deptId, subdeptId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading articles: {error}</div>;
  if (!articles.length) return <div>No articles available.</div>;

  const title = f(subdeptDoc, "name") || t({ en: "Our Articles", fr: "Nos articles" });
const description = f(subdeptDoc, "description");

return (
  <div className="px-4 md:px-8 py-10">
    <h1 className="text-2xl font-bold text-center mb-4">{title}</h1>

    {/* ⭐ Show subdepartment description */}
    {description && (
      <p className="text-center text-gray-600 max-w-3xl mx-auto mb-10 text-lg">
        {description}
      </p>
    )}

    <Article data={articles} title={title} showTitle={false} />
  </div>
);

};

export default SubdepartmentArticles;
